import { useRef, useEffect, useId } from "react";
import searchComponent from "@skat/bbr-searchcomponent";
import type { SearchResult } from "@skat/bbr-searchcomponent";
import type { Initialize } from "@skat/bbr-searchcomponent";

export default function Search({
  onResult,
}: {
  onResult: (item: SearchResult) => void;
}) {
  const instanceId = useId();
  const containerRef = useRef<HTMLDivElement>(null);
  const instanceRef = useRef<ReturnType<
    typeof searchComponent.createInstance
  > | null>(null);
  const onResultRef = useRef(onResult);

  useEffect(() => {
    onResultRef.current = onResult;
  });

  useEffect(() => {
    if (!containerRef.current) return;
    try {
      instanceRef.current = searchComponent.createInstance({
        instanceId,
        elementOrSelector: containerRef.current,
        behavior: {},
        datafordeleren: {
          dafApiKey: import.meta.env.VITE_DAF_API_KEY || "",
        },
        sources: [
          {
            name: "adressevaelger.adresse",
            options: {
              fetchExtendedResult: true,
            },
          },
          {
            name: "dawa.jordstykke",
            options: {
              fetchExtendedResult: true,
            },
          },
          {
            name: "daf.ejendom",
            options: {
              fetchExtendedResult: true,
            },
          },
        ],
        layout: {
          width: "100%",
        },
        localization: {
          placeholder: "Søg på adresse, BFE-nummer eller matrikel",
        },
        events: {
          itemSelected: (item: SearchResult) => {
            onResultRef.current(item);
          },
        },
      } as Initialize);
    } catch (error) {
      console.log(error);
    }

    return () => {
      instanceRef.current?.destroy();
    };
  }, []); // run once on mount

  return <div style={{ width: "100%" }} ref={containerRef} />;
}
